export const SET_PHONE = 'SET_PHONE'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const TOGGLE_GET_HELP_MENU = 'TOGGLE_GET_HELP_MENU'

export const SET_LOGO = 'SET_LOGO'
export const SET_MENU = 'SET_MENU'
export const TOGGLE_MENU = 'TOGGLE_MENU'
export const TOGGLE_IS_MOBILE = 'TOGGLE_IS_MOBILE'
export const TOGGLE_MENU_ITEM = 'TOGGLE_MENU_ITEM'
export const SET_TOP_POSITION = 'SET_TOP_POSITION'

export const TOGGLE_BOT = 'TOGGLE_BOT'
export const TOGGLE_INITIAL_ANIMATION = 'TOGGLE_INITIAL_ANIMATION'
export const TOGGLE_MOBILE_INFORMATION = 'TOGGLE_MOBILE_INFORMATION'
export const SET_INFORMATION_BUTTON_RIGHT_POSITION = 'SET_INFORMATION_BUTTON_RIGHT_POSITION'

export const SET_STICKY_MENU = 'SET_STICKY_MENU'
export const ADD_ACTIVE_ITEM = 'ADD_ACTIVE_ITEM'
export const UNSET_STICKY_MENU = 'UNSET_STICKY_MENU'
export const PURGE_ACTIVE_ITEMS = 'PURGE_ACTIVE_ITEMS'
export const REMOVE_ACTIVE_ITEM = 'REMOVE_ACTIVE_ITEM'

export const SET_STICKY_SECOND_MENU = 'SET_STICKY_SECOND_MENU'
export const UNSET_STICKY_SECOND_MENU = 'UNSET_STICKY_SECOND_MENU'

export const HIDE_GLOBAL_MODAL = 'HIDE_GLOBAL_MODAL'
export const SHOW_GLOBAL_MODAL = 'SHOW_GLOBAL_MODAL'
export const SET_GLOBAL_MODAL_TITLE = 'SET_GLOBAL_MODAL_TITLE'
export const SET_GLOBAL_MODAL_WIDTH = 'SET_GLOBAL_MODAL_WIDTH'
export const SET_GLOBAL_MODAL_CONTENT = 'SET_GLOBAL_MODAL_CONTENT'

export const ADD_ALGOLIA_RESULTS = 'ADD_ALGOLIA_RESULTS'
export const RESET_ALGOLIA_RESULTS = 'RESET_ALGOLIA_RESULTS'